function setAuthMapping(user) {
    localStorage.setItem('Authorization', JSON.stringify(user));
}

function getAuthMapping(){
    return JSON.parse(localStorage.getItem('Authorization'));
}

function removeAuthMapping(){
    localStorage.removeItem('Authorization');
}

export {setAuthMapping, getAuthMapping, removeAuthMapping};